import React, { useState, useEffect } from 'react';
import { Form, Input, Select, Checkbox, Tree, Row, Col, message, Button } from 'antd';
import ModalDom from '../../../../components/Modal';
import { get, post, postFrom, config } from '../../../../axios';
import { CustomRow, CustomCol } from '../../../../components/Custom';

const Option = Select.Option;

const ChannelUpdate = props => {
    const [loading, setLoading] = useState(false)
    const [title, setTitle] = useState('')
    const [employeeList, setEmployeeList] = useState([])
    const { modalData, visible, handleFindPage, handleCancel, form: { getFieldDecorator, setFieldsValue } } = props

    useEffect(() => {
        setTitle(modalData.id ? '修改' : '新增')
        postFindEmployeeList()
    }, [modalData])

    const handleOk = () => {
        let nowUrl = config.API_channel_add
        if (modalData.id) {
            nowUrl = config.API_channel_update
        }
        props.form.validateFieldsAndScroll((error, value) => {
            setLoading(true)
            post({
                url: nowUrl,
                data: { ...modalData, ...value }
            }).then(res => {
                setLoading(false)
                handleFindPage()
                message.success('更新成功!')
                handleCancel()
            }).catch(err => {
                message.error(err.message || '接口异常');
                setLoading(false)
            })
        })
    }

    const handleGetToken = () => {
        postGetToken().then(res => {
            setFieldsValue({ token: res })
        })
    }

    const postGetToken = () => {
        return new Promise(resolve => {
            setLoading(true)
            get({
                url: config.API_channel_getToken,
            }).then(res => {
                resolve(res)
                setLoading(false)
            }).catch(err => {
                message.error(err.message || '获取 token 失败!');
                resolve('')
                setLoading(false)
            });
        })
    }

    const postFindEmployeeList = () => {
      setLoading(true)
      postFrom({
        url: config.API_employee_findEmployeeList
      }).then(res => {
        const employeeList = []
        res.forEach(item => {
          employeeList.push({
            title: item.name,
            value: item.id
          })
        })
        setLoading(false)
        setEmployeeList(employeeList)
      }).catch(err => {
        message.error(err.message || '接口异常')
        setLoading(false)
      })
    }

    return (
        <ModalDom
            title={title}
            visible={visible}
            width="800px"
            loading={loading}
            onOk={handleOk}
            onCancel={handleCancel}
        >
             <div className="custom" >
                <Form
                    className="min-height"
                >
                    <Row>
                        <Col span={23} offset={1} >
                            <CustomRow>
                                <CustomCol  label="渠道名称">
                                        {getFieldDecorator('name', {
                                            rules: [{
                                                required: true, message: '请输入渠道名称',
                                            }],
                                            initialValue: modalData.name
                                        })(
                                            <Input 
                                                    placeholder={'请输入'}
                                                autoComplete={'off'}
                                            />
                                        )}
                                </CustomCol>
                            </CustomRow>
                            {
                                title === '新增' ? (
                                    <CustomRow divider>
                                        <CustomCol  label="渠道token">
                                                {getFieldDecorator('token', {
                                                    rules: [{
                                                        required: true, message: '请获取渠道token',
                                                    }],
                                                    initialValue: modalData.token
                                                })(
                                                    <Input 
                                                            placeholder={'请输入'}
                                                        autoComplete={'off'}
                                                    />
                                                )}
                                        </CustomCol>
                                        <Button type="primary" style={{ margin: '2px 10px' }} onClick={handleGetToken}>获取</Button>
                                    </CustomRow>
                                ) : null
                            }
                            <CustomRow divider>
                            <CustomCol  label="渠道负责人">
                                    {getFieldDecorator('channelHead', {
                                        initialValue: modalData.channelHead
                                    })(
                                      <Select
                                      showSearch
                                        placeholder="请选择"
                                        optionFilterProp={'children'}
                                      >
                                        {employeeList.map((item, index) => <Option key={ index } value={ item.value }>{ item.title }</Option>)}
                                      </Select>
                                    )}
                            </CustomCol>
                          </CustomRow>
                        </Col>
                    </Row>
                </Form>
             </div>
        </ModalDom>
    )
}

export default Form.create()(ChannelUpdate);


// WEBPACK FOOTER //
// ./src/page/Employee/components/ChannelUpdate/index.jsx